module.exports = __webpack_public_path__ + "img/the-trustline.6a9e5004.png";